import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { TextFieldWithLabel } from 'shared/ui'
import { makeTextFieldAutoFocus } from 'shared/ui/TextField'
import type { TeamsStore } from 'pages/settings/pages/teams/store/TeamsStore'
import styles from './styles.module.scss'

const NAME_EMPTY_ERROR = "This field can't be empty"

export type IRenameTeamModalContentProps = {
  store: TeamsStore
}

export const RenameTeamModalContent = observer(({ store }: IRenameTeamModalContentProps) => {
  const [nameError, setNameError] = useState<string | undefined>(undefined)

  const handleNameChange = (value: string) => {
    store.setRenameTeamName(value)
    if (value.trim() !== '') setNameError(undefined)
  }

  const handleNameBlur = () => {
    if (store.renameTeamName.trim() === '') {
      setNameError(NAME_EMPTY_ERROR)
    } else {
      setNameError(undefined)
    }
  }

  return (
    <div className={styles.container}>
      <TextFieldWithLabel
        labelProps={{ label: { text: 'Name' } }}
        limit={40}
        errorMessage={nameError}
        textFieldProps={{
          value: store.renameTeamName,
          onChange: handleNameChange,
          onBlur: handleNameBlur,
          InputProps: { placeholder: 'Enter team name' },
          variant: 'stroke',
          size: 'medium',
          mainActions: [makeTextFieldAutoFocus({ withFocus: true })],
        }}
      />
      <TextFieldWithLabel
        labelProps={{ label: { text: 'Description (optional)' } }}
        textFieldProps={{
          value: store.renameTeamDescription,
          onChange: store.setRenameTeamDescription,
          InputProps: { placeholder: 'Enter description' },
          variant: 'stroke',
          size: 'medium',
        }}
      />
    </div>
  )
})
